<template>
  <div class="container">
    <loading :active="loading" :is-full-page="true" loader="bars"></loading>
    <div class="row">
      <div class="col-md-8 mt-5 mx-auto">
        <router-link to="/faq" class="btn btn-sm btn-primary mb-3"
          >Back</router-link
        >
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Edit FAQ</h4>
          </div>
          <div class="card-body">
            <form @submit.prevent="submit">
              <div class="form-group">
                <label>Question <span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control mb-3"
                  required
                  v-model="faq.question"
                />
              </div>
              <div class="form-group">
                <label>Answer <span class="text-danger">*</span></label>
                <textarea
                  class="form-control mb-3"
                  required
                  v-model="faq.answer"
                ></textarea>
              </div>
              <div class="row mt-3">
                <div class="col-md-9">
                  <button type="submit" class="btn btn-lg btn-primary w-100">
                    Save
                  </button>
                </div>
                <div class="col-md-3">
                  <button
                    type="reset"
                    class="btn btn-lg btn-outline-danger w-100"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { toRaw } from "vue";

export default {
  data() {
    return {
      faq: {
        question: null,
        answer: null,
      },
      loading: false,
      id: null,
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.fetch(this.id);
  },
  methods: {
    fetch(id) {
      this.loading = true;
      this.$store
        .dispatch("faq/getSingle", { id })
        .then((response) => {
          this.faq = response.data;
          this.loading = false;
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },
    submit() {
      this.loading = true;
      const data = toRaw(this.faq);
      this.$store
        .dispatch("faq/update", { data })
        .then((response) => {
          this.loading = false;
          if (response.success === true) {
            this.$toast.show("Successfuly updated", {
              theme: "outline",
              position: "top",
              type: "success",
              duration: 5000,
            });
          } else {
            this.$toast.show("Failed to save", {
              theme: "outline",
              position: "top",
              type: "error",
              duration: 5000,
            });
          }
        })
        .catch((e) => {
          this.loading = false;
          this.$toast.show(e.error, {
            theme: "outline",
            position: "top",
            type: "error",
            duration: 10000,
          });
        });
    },
  },
};
</script>
